import { Link } from 'react-router-dom';
import { BookOpen, Lock } from 'lucide-react';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../components/ui/card.tsx';
import { usePermissions } from '../hooks/usePermissions.ts';
import { visibleDocs } from '../docs/index.ts';

export function DocsIndexPage() {
  const { userGroups } = usePermissions();
  const entries = visibleDocs(userGroups);

  return (
    <div className='space-y-6'>
      <div>
        <h1 className='text-3xl font-bold'>Docs</h1>
        <p className='text-muted-foreground mt-1'>
          Reference material for using and administering Wellspring
        </p>
      </div>

      {entries.length === 0 && (
        <p className='text-muted-foreground'>No docs are available for your role.</p>
      )}

      <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4'>
        {entries.map((doc) => (
          <Link key={doc.slug} to={`/docs/${doc.slug}`} className='block'>
            <Card className='hover:bg-accent/50 transition-colors cursor-pointer h-full'>
              <CardHeader className='pb-2'>
                <div className='flex items-center gap-2'>
                  <BookOpen className='h-5 w-5 text-muted-foreground' />
                  <CardTitle className='text-lg'>{doc.title}</CardTitle>
                  {doc.requiredPermission && (
                    <Lock
                      className='h-4 w-4 text-muted-foreground ml-auto'
                      aria-label='Restricted'
                    />
                  )}
                </div>
              </CardHeader>
              <CardContent>
                <CardDescription>{doc.description}</CardDescription>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
